import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

const PATRON_CMP_STATUS_QUERY_V2 = gql`
  query {
    statusV2 {
      cmpPlayerStatus {
        found
        patronAccountNumber
        patronInfo {
          firstName
          lastName
          email
          birthDate
          rewardsJoinDate
          homePhone
          mobilePhone
          gender
          address1
          address2
          city
          stateProvince
          postalCode
        }
        freePlay
        shoppingDollars
        basePoints
        clubState
        nextClubState
        pointsNeeded
        basePointsEarned
        drawings {
          name
          amount
        }
      }
    }
  }
`;

export default graphql(PATRON_CMP_STATUS_QUERY_V2, { name: 'statusCmpData' });
